<template>
  <form class="odin-request" @submit.prevent="submit" ref="requestForm">
    <div class="form-eyebrow">
      NON-BINDING ROBOT PRE-ORDER REQUEST <span>↗</span>
    </div>
    <div class="form-field">
      <label for="odin-email">Email address <span>required</span></label
      ><input
        id="odin-email"
        v-model.trim="form.email"
        type="email"
        autocomplete="email"
        maxlength="254"
        required
        :disabled="sending || accepted"
      />
    </div>
    <div class="form-row">
      <div class="form-field">
        <label for="odin-name">Name <span>optional</span></label
        ><input
          id="odin-name"
          v-model.trim="form.name"
          autocomplete="name"
          maxlength="100"
          :disabled="sending || accepted"
        />
      </div>
      <div class="form-field">
        <label for="odin-sites">Number of websites <span>optional</span></label
        ><select
          id="odin-sites"
          v-model="form.websites"
          :disabled="sending || accepted"
        >
          <option value="">Select</option>
          <option>1</option>
          <option>2–10</option>
          <option>11–50</option>
          <option>51+</option>
        </select>
      </div>
    </div>
    <div class="form-field">
      <label for="odin-message"
        >What would you like ODIN to help with? <span>optional</span></label
      ><textarea
        id="odin-message"
        v-model="form.message"
        rows="3"
        maxlength="2000"
        :disabled="sending || accepted"
        placeholder="A little about your workflow…"
      ></textarea>
    </div>
    <div class="odin-trap" aria-hidden="true">
      <label for="odin-company">Leave this field empty</label
      ><input
        id="odin-company"
        v-model="form.company"
        tabindex="-1"
        autocomplete="off"
      />
    </div>
    <label class="acknowledgement"
      ><input
        type="checkbox"
        v-model="form.acknowledged"
        required
        :disabled="sending || accepted"
      /><span
        >I understand that the ODIN robot is a prototype in development. This is a
        non-binding request, not a confirmed order. No payment is required.
        Final features, pricing and availability are not yet confirmed.</span
      ></label
    >
    <p class="form-privacy">
      We’ll use your email to respond about this request and product
      availability. This does not subscribe you to a newsletter.
      <a href="/privacy-policy">Privacy policy ↗</a>
    </p>
    <button
      class="green-btn odin-button"
      type="submit"
      :disabled="sending || accepted"
    >
      {{
        sending
          ? "Sending request…"
          : accepted
            ? "Request received ✓"
            : "Send robot pre-order request"
      }}<span v-if="!sending && !accepted" aria-hidden="true">↗</span>
    </button>
    <div
      v-if="feedback"
      ref="feedback"
      tabindex="-1"
      class="form-feedback"
      :class="{ 'is-error': !accepted }"
      :role="accepted ? 'status' : 'alert'"
    >
      {{ feedback }}
    </div>
    <p v-if="accepted" class="form-privacy">
      The mail server accepted your request for delivery. This is not a delivery
      guarantee or a confirmed order.
    </p>
    <div v-if="fallback" class="email-fallback">
      <a :href="mailto">Request by email ↗</a>
      <p>
        Opens your email application with a draft to ARI’s configured recipient.
        Review and send it there; opening the draft does not send a request.
      </p>
    </div>
    <span class="form-bottom"
      >No payment. No commitment. Just a first hello.</span
    >
  </form>
</template>
<script>
const { validateRequest, submitRequest } = require("./request");
export default {
  name: "OdinRequest",
  data() {
    return {
      form: {
        email: "",
        name: "",
        websites: "",
        message: "",
        company: "",
        acknowledged: false,
      },
      sending: false,
      accepted: false,
      feedback: "",
      fallback: false,
      requestId: "",
      started: Date.now(),
    };
  },
  computed: {
    mailto() {
      const body = `ODIN robot — non-binding pre-order request\n\nEmail: ${this.form.email}\nName: ${this.form.name}\nWebsites: ${this.form.websites}\nIntended use: ${this.form.message}\n\nI understand this is a prototype in development and a non-binding request. No payment is required. Final features, pricing and availability are unconfirmed.\nSource: https://www.ari.company/odin`;
      return `mailto:manager@ari.company?subject=${encodeURIComponent("ODIN robot — New pre-order request")}&body=${encodeURIComponent(body)}`;
    },
  },
  methods: {
    async submit() {
      if (this.sending || this.accepted) return;
      const invalid = validateRequest(this.form);
      if (invalid) {
        this.feedback = invalid;
        return;
      }
      this.sending = true;
      this.feedback = "";
      this.fallback = false;
      if (!this.requestId)
        this.requestId = window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : Array.from(window.crypto.getRandomValues(new Uint8Array(16)), (b) =>
              b.toString(16).padStart(2, "0"),
            ).join("");
      try {
        const result = await submitRequest(
          {
            ...this.form,
            request_id: this.requestId,
            elapsed_ms: Date.now() - this.started,
          },
          process.env.VUE_APP_ODIN_API_URL ||
            (["ari.company", "www.ari.company"].includes(
              window.location.hostname,
            )
              ? "https://api.ari.company/api/odin/preorder"
              : "/api/odin/preorder"),
        );
        this.accepted = result.accepted;
        this.feedback = result.message;
        this.fallback = !result.accepted;
      } catch (e) {
        this.feedback =
          "We could not confirm that your request was received. Please retry, or use Request by email below.";
        this.fallback = true;
      } finally {
        this.sending = false;
        this.$nextTick(() => {
          if (this.$refs.feedback) this.$refs.feedback.focus();
        });
      }
    },
  },
};
</script>
